/**
 * Datos institucionales que hoy no vienen del backend.
 *
 * CONTACT_EMAIL se usa en el bloque de contacto de la home. Está tomado de las
 * casillas que ya usa el servicio (`config_db_task.php`); confirmá cuál quieren
 * publicar antes de salir a producción.
 */
export const CONTACT_EMAIL = "ventas@belimport.com";

export const COMPANY_NAME = "Belimport S.A.";

export const INSTAGRAM_URL = "https://www.instagram.com/belimport_sa/";
